import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../Components/InnerLayout/Headerbar";
import UserInterface from "../Components/InnerLayout/UserInterface";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  AreaChart,
  Area,
  ComposedChart,
} from "recharts";

const CustomTooltip = ({ active, payload, label }) => {
  console.log(active, payload, label);

  if (active && payload && payload.length) {
    return (
      <div className="custom-tooltip">
        <p className="label">{`${label} : ${payload[0].value}`}</p>
        <p className="desc">Anything you want can be displayed here.</p>
      </div>
    );
  }

  return null;
};

const Home = (params) => {
  // Dahsboard Chart
  const data = [
    {
      name: "1",
      uv: 4000,
      pv: 2400,
      amt: 2400,
    },
    {
      name: "2",
      uv: 3000,
      pv: 1398,
      amt: 2210,
    },
    {
      name: "3",
      uv: 2000,
      pv: 9800,
      amt: 2290,
    },
    {
      name: "4",
      uv: 2780,
      pv: 3908,
      amt: 2000,
    },
    {
      name: "5",
      uv: 1890,
      pv: 4800,
      amt: 2181,
    },
    {
      name: "6",
      uv: 2390,
      pv: 3800,
      amt: 2500,
    },
  ];

  const [graphDimensions, setgraphDimensions] = useState({
    height: null,
    width: null,
  });

  useEffect(() => {
    const dimensions = document
      .querySelector(".sales_graph")
      .getBoundingClientRect();
    setgraphDimensions({
      height: dimensions.height,
      width: dimensions.width,
    });
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row mx-0">
              <div className="container px-0">
                <div class="top-logos d-flex flex-wrap">
                  <div class="col-sm-6 col-12 custom_re_width d-flex align-left">
                    <figure class="uploaded-logo">
                      <span class="img_cloog">
                        <img
                          src="https://uat.gogmgo.com/merchant_logos/1642505762.png"
                          alt="logo"
                        />
                      </span>
                    </figure>
                    <div class="col-sm-6">
                      <h4 className="mb-0"> Harry's HQ </h4>
                      <span class="gry-txt"> Welcome Back, Admin! </span>
                    </div>
                  </div>

                  <div class="col-sm-6 col-12 align-right custom_re_width">
                    <div class="right-desc">
                      <div class="wthr-img">
                        <img src="https://openweathermap.org/img/wn/04d@2x.png" />
                      </div>
                      <div class="weather-para">
                        <p>Singapore, Singapore</p>
                        <p>May 31, 2022 02:47pm</p>
                        <p>Clouds 32 °C </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row mx-0">
              <div class="shadowclass top_filters orderpayy mt-0 mt-sm-3">
                <h4 class="event-alert py-0 my-2">Daily Sales</h4>
                <div class="row-fluid">
                  <div class="col-12">
                    <div class="counts date_new_Cont row align-items-start mx-0">
                      <div className="col-lg-7 col-12 px-0 px-sm-2">
                        <div className="d-flex align-items-center justify-content-between flex-wrap">
                          <div class="calendr m-0 col-sm-6 col-12">
                            <a href="?date_start=2022-05-30">
                              <i class="iconSprites arrow-left"></i>
                            </a>
                            <div class="text">
                              <span>31</span>
                              <small>
                                Tuesday <br />
                                May 2022
                              </small>
                            </div>
                            <a href="#_" id="cal_open2">
                              <i class="iconSprites cal-icon"></i>
                            </a>
                          </div>
                          <div class="right-desc col-6 align-right">
                            <a
                              href="/finance_summary/sales/timeLimit:day/dateStart:2022-05-31"
                              class="text-right bold"
                            >
                              View Sales
                            </a>
                          </div>
                        </div>
                        <div className="row">
                          <div className="graph-sec col-12">
                            <div
                              className="sales_graph"
                              style={{ height: "309px", width: "100%" }}
                            >
                              <ComposedChart
                                width={graphDimensions.width || 100}
                                height={graphDimensions.height || 100}
                                data={data}
                                margin={{
                                  top: 5,
                                  right: 30,
                                  left: 20,
                                  bottom: 5,
                                }}
                              >
                                {/* <CartesianGrid strokeDasharray="3 3" /> */}
                                <XAxis dataKey="name" />
                                <YAxis />
                                <Tooltip content={<CustomTooltip />} />
                                <Legend />
                                <Line
                                  type=""
                                  dataKey="pv"
                                  stroke="#b6b7b7"
                                  strokeWidth={"2"}
                                  dot={{ r: 8 }}
                                  activeDot={{ r: 8 }}
                                />
                                <Area
                                  dataKey="uv"
                                  stroke="#82ca9d"
                                  fill="#dffbf8"
                                />
                              </ComposedChart>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-5 col-12 d-flex align-items-center justify-content-end">
                        <div class="half_right_div mt-0">
                          <div class="sales_today">
                            <ul class="summary_filter add links-row">
                              <li class="ico-sec">
                                <a className="get_sales_today selected">
                                  <span class="text_right_ss border_botom CurrencyType">
                                    $
                                  </span>
                                </a>
                              </li>
                              <li class="ico-sec">
                                <a className="get_sales_today">
                                  <span class="text_right_ss">#</span>
                                </a>
                              </li>
                              <li class="ico-sec">
                                <a className="get_sales_today">
                                  <span class="text_right_ss">$/#</span>
                                </a>
                              </li>
                              <li class="">
                                <a>Summary</a>
                              </li>
                              <li class="">
                                <a>Detail</a>
                              </li>
                            </ul>
                            <div class="table-responsive sales-table ">
                              <div class="scrolling-sec">
                                <table class="checklist-table table daily-sales">
                                  <thead>
                                    <tr>
                                      <th>
                                        <div> </div>
                                      </th>
                                      <th>
                                        <div> </div>
                                      </th>
                                      <th width="20%" class="gross-sale">
                                        <div> Gross Item Sales</div>
                                      </th>
                                      <th width="20%" class="gross-sale">
                                        <div>Net Sales </div>
                                      </th>
                                      <th width="20%" class="gross-sale">
                                        <div>% of Day </div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr class="removeEmptyTd">
                                      <td>
                                        {" "}
                                        <i class="icon-visa"></i>
                                      </td>
                                      <td>Visa</td>
                                      <td>$90.00 </td>
                                      <td>$99.00 </td>
                                      <td>84.1</td>
                                    </tr>
                                    <tr class="removeEmptyTd">
                                      <td>
                                        {" "}
                                        <i class="icon-visa"></i>
                                      </td>
                                      <td>NETS</td>
                                      <td>$17.00 </td>
                                      <td>$18.70 </td>
                                      <td>15.9</td>
                                    </tr>
                                    <tr class="blank_tr">
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr class="blank_tr">
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr class="blank_tr">
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr class="blank_tr">
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td class="blue_text bold">
                                        <div>&nbsp; </div>
                                      </td>
                                      <td class="blue_text bold">
                                        <div>Total </div>
                                      </td>

                                      <td class="bold totalCol">
                                        <div> $107.00 </div>
                                      </td>

                                      <td class="bold totalCol">
                                        <div> $117.70 </div>
                                      </td>

                                      <td class="bold totalCol">
                                        <div> 100 </div>
                                      </td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0">
              <div className="container d-flex px-0 flex-wrap">
                <div className="col-lg-7 col-12 tableSecMs">
                  <div className="shadowclass">
                    <div className="top-header-sec d-flex justify-content-between flex-wrap">
                      <h3 class="event-alert h4 mb-0 col-12 col-sm-auto">Pending Actions</h3>
                      <ul
                        class="nav summary_filter col-md-8 col-12"
                        id="pills-tab"
                        role="tablist"
                      >
                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link active"
                            id="pills-payment-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-payment"
                            type="button"
                            role="tab"
                            aria-controls="pills-payment"
                            aria-selected="true"
                          >
                            Payments
                          </a>
                        </li>
                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link"
                            id="pills-orders-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-orders"
                            type="button"
                            role="tab"
                            aria-controls="pills-orders"
                            aria-selected="false"
                          >
                            Orders
                          </a>
                        </li>

                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link"
                            id="pills-invoices-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-invoices"
                            type="button"
                            role="tab"
                            aria-controls="pills-invoices"
                            aria-selected="false"
                          >
                            Invoices
                          </a>
                        </li>

                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link"
                            id="pills-labor-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-labor"
                            type="button"
                            role="tab"
                            aria-controls="pills-labor"
                            aria-selected="false"
                          >
                            Labor
                          </a>
                        </li>

                        <li class="nav-item" role="presentation">
                          <a
                            class="nav-link"
                            id="pills-counts-tab"
                            data-bs-toggle="pill"
                            data-bs-target="#pills-counts"
                            type="button"
                            role="tab"
                            aria-controls="pills-counts"
                            aria-selected="false"
                          >
                            Counts
                          </a>
                        </li>
                      </ul>
                    </div>

                    <div className="row_1">
                      <div class="tab-content" id="pills-tabContent">
                        <div
                          class="tab-pane fade show active"
                          id="pills-payment"
                          role="tabpanel"
                          aria-labelledby="pills-payment-tab"
                        >
                          <div class="pending_action">
                            <div class="table-responsive">
                              <table class="table table-brdr">
                                <tbody>
                                  <tr>
                                    <td>
                                      <span class="pending_status">
                                        {" "}
                                        Pending{" "}
                                      </span>
                                      <h4> 126 Days </h4>
                                    </td>
                                    <td className="min-wd-200">
                                      <b>Harry's HQ |</b>
                                      <b>Pending Payment | </b>{" "}
                                      <i>Pay Non-Trade Order</i> <br />
                                      Abt Medical Products Pte Ltd{" "}
                                    </td>
                                    <td class="lbr_name">$428.00 </td>
                                    <td>
                                      <a
                                        href="/payments/edit_payment/148"
                                        class="btn green-btn-revert btn-sm"
                                      >
                                        View{" "}
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span class="pending_status">
                                        {" "}
                                        Pending{" "}
                                      </span>
                                      <h4> 98 Days </h4>
                                    </td>
                                    <td>
                                      <b>Harry's HQ |</b>
                                      <b>Pending Payment | </b>{" "}
                                      <i>Pay AP Liability</i> <br />
                                      Royalton Wine &amp; Spirits Pte Ltd{" "}
                                    </td>
                                    <td class="lbr_name">$1,600.00 </td>
                                    <td>
                                      <a
                                        href="/payments/edit_payment/151"
                                        class="btn green-btn-revert btn-sm"
                                      >
                                        {" "}
                                        View{" "}
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span class="pending_status">
                                        {" "}
                                        Pending{" "}
                                      </span>
                                      <h4> 94 Days </h4>
                                    </td>
                                    <td>
                                      <b>Boat Quay Pilot |</b>
                                      <b>Pending Payment | </b>{" "}
                                      <i>Pay Non-Trade Order</i> <br />
                                      Tom's Butchery Pte Ltd{" "}
                                    </td>
                                    <td class="lbr_name">$130.00 </td>
                                    <td>
                                      <a
                                        href="/payments/edit_payment/153"
                                        class="btn green-btn-revert btn-sm"
                                      >
                                        {" "}
                                        View{" "}
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span class="pending_status">
                                        {" "}
                                        Pending{" "}
                                      </span>
                                      <h4> 17 Days </h4>
                                    </td>
                                    <td>
                                      <b>Harry's HQ |</b>
                                      <b>Pending Payment | </b>{" "}
                                      <i>Pay Non-Trade Order</i> <br />A &amp; P
                                      Maintenance Services Pte Ltd{" "}
                                    </td>
                                    <td class="lbr_name">$1,070.00 </td>
                                    <td>
                                      <a
                                        href="/payments/edit_payment/157"
                                        class="btn green-btn-revert btn-sm"
                                      >
                                        {" "}
                                        View{" "}
                                      </a>
                                    </td>
                                  </tr>
                                  <tr>
                                    <td>
                                      <span class="pending_status">
                                        {" "}
                                        Pending{" "}
                                      </span>
                                      <h4> 17 Days </h4>
                                    </td>
                                    <td>
                                      <b>Harry's HQ |</b>
                                      <b>Pending Payment | </b>{" "}
                                      <i>Pay Non-Trade Order</i> <br />
                                      A-Speed Infotech Pte Ltd{" "}
                                    </td>
                                    <td class="lbr_name">$2,140.00 </td>
                                    <td>
                                      <a
                                        href="/payments/edit_payment/158"
                                        class="btn green-btn-revert btn-sm"
                                      >
                                        {" "}
                                        View{" "}
                                      </a>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="pills-orders"
                          role="tabpanel"
                          aria-labelledby="pills-orders-tab"
                        >
                          <div class="pending_action">
                            <table class="table table-brdr">
                              <tbody>
                                <tr>
                                  <td colspan="4">
                                    {" "}
                                    <b>No pending actions.</b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                        <div
                          class="tab-pane fade"
                          id="pills-invoices"
                          role="tabpanel"
                          aria-labelledby="pills-invoices-tab"
                        >
                          <div class="pending_action">
                            <table class="table table-brdr">
                              <tbody>
                                <tr>
                                  <td colspan="4">
                                    {" "}
                                    <b>No pending actions.</b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div
                          class="tab-pane fade"
                          id="pills-labor"
                          role="tabpanel"
                          aria-labelledby="pills-labor-tab"
                        >
                          <div class="pending_action">
                            <table class="table table-brdr">
                              <tbody>
                                <tr>
                                  <td colspan="4">
                                    {" "}
                                    <b>No pending actions.</b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div
                          class="tab-pane fade"
                          id="pills-counts"
                          role="tabpanel"
                          aria-labelledby="pills-counts-tab"
                        >
                          <div class="pending_action">
                            <table class="table table-brdr">
                              <tbody>
                                <tr>
                                  <td colspan="4">
                                    {" "}
                                    <b>No pending actions.</b>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-5 col-12 tableSecMs pr0 px-0 px-lg-3">
                  <div className="shadowclass">
                    <div className="top-header-sec d-flex justify-content-between mb-0">
                      <h3 class="event-alert h4 mb-0">Update Center</h3>
                    </div>
                    <div class="links-row">
                      <a
                        href="javascript:void(0)"
                        class="weekly_prime_data"
                        val="last_updates"
                      >
                        <span class="text_right_ss border_botom">
                          Last Updates
                        </span>
                      </a>
                      <div className="update-table-sec">
                        <table class="table bullet-table">
                          <tbody id="TransSearch">
                            <tr class="active">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b>
                                  {" "}
                                  CapitaLand Voucher Voucher Usage 05/31/2022{" "}
                                </b>
                                <br />
                                Today | 04:37pm |{" "}
                              </td>
                              <td class="price-td">$35.00 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Prepared Dishes </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$142.78 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b>
                                  {" "}
                                  Cost of Goods Sold - Non-Alcoholic Beverages{" "}
                                </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$31.66 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Spirits </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$6.09 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Wine </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$14.40 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Beer </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$19.90 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Oils &amp; Juices </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$1.04 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Dairy </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$9.29 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Produce </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$9.01 </td>
                            </tr>
                            <tr class="">
                              <td>
                                <b>Boat Quay Pilot |</b>
                                <b> Cost of Goods Sold - Carbohydrates </b>
                                <br />
                                Today | 02:17pm | Admin BQ{" "}
                              </td>
                              <td class="price-td">$7.01 </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>

                    <div className="row"></div>
                  </div>
                </div>
              </div>
            </div>

            <div className="row mx-0">
              <div className="container px-0">
                <div className="shadowclass">
                  <div className="top-header-sec d-flex justify-content-between flex-wrap">
                    <h4 class="event-alert col-sm-auto col-12">Weekly Prime Costs</h4>
                    <ul
                      class="nav summary_filter col-md-4"
                      id="pills-tab"
                      role="tablist"
                    >
                      <li class="nav-item" role="presentation">
                        <a
                          class="nav-link active"
                          id="pills-home-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-home"
                          type="button"
                          role="tab"
                          aria-controls="pills-home"
                          aria-selected="true"
                        >
                          Summary
                        </a>
                      </li>
                      <li class="nav-item" role="presentation">
                        <a
                          class="nav-link"
                          id="pills-profile-tab"
                          data-bs-toggle="pill"
                          data-bs-target="#pills-profile"
                          type="button"
                          role="tab"
                          aria-controls="pills-profile"
                          aria-selected="false"
                        >
                          Detail
                        </a>
                      </li>
                    </ul>
                  </div>

                  <div className="clearfix"> </div>

                  <div className="row_1 mx-0 my-4">
                    <div class="tab-content" id="pills-tabContent">
                      <div
                        class="tab-pane fade show active"
                        id="pills-home"
                        role="tabpanel"
                        aria-labelledby="pills-home-tab"
                      >
                        <div className="table-responsive">
                          <table className="checklist-table remove-space inventory_table">
                            <thead>
                              <tr>
                                <th width=""> </th>
                                <th width="">
                                  Wednesday
                                  <br />
                                  May 25
                                </th>
                                <th width="">
                                  Thursday
                                  <br />
                                  May 26
                                </th>
                                <th width="">
                                  Friday
                                  <br />
                                  May 27
                                </th>
                                <th width="">
                                  Saturday
                                  <br />
                                  May 28
                                </th>
                                <th width="">
                                  Sunday
                                  <br />
                                  May 29
                                </th>
                                <th width="">
                                  Monday
                                  <br />
                                  May 30
                                </th>
                                <th width="">
                                  Tuesday
                                  <br />
                                  May 31
                                </th>
                                <th width="">Total</th>
                                <th width="">% of Revenue</th>
                                <th width="">Vs. Forecast</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="blue_text bold">Revenue</td>
                                <td class="blue_text bold">$55.00</td>
                                <td class="blue_text bold">$312.80</td>
                                <td class="blue_text bold">$0.00</td>
                                <td class="blue_text bold">$400.40</td>
                                <td class="blue_text bold">$101.31</td>
                                <td class="blue_text bold">$335.64</td>
                                <td class="blue_text bold">$117.70</td>
                                <td class="blue_text bold">$1,322.85</td>
                                <td class="blue_text bold">100</td>
                                <td class="blue_text bold">Not Applicable </td>
                              </tr>

                              <tr>
                                <td class="blue_text bold">COGS</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($294.42)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($294.42)</td>
                                <td class="blue_text bold">22.26 </td>
                                <td class="blue_text bold">Not Applicable </td>
                              </tr>
                              <tr>
                                <td class="blue_text bold">Labor</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">0.00 </td>
                                <td class="blue_text bold">Not Applicable </td>
                              </tr>

                              <tr>
                                <td class="yellow_text bold">PRIME COST</td>
                                <td class="yellow_text bold">$0.00</td>
                                <td class="yellow_text bold">$0.00</td>
                                <td class="yellow_text bold">$0.00</td>
                                <td class="yellow_text bold">$0.00</td>
                                <td class="yellow_text bold">$0.00</td>
                                <td class="yellow_text bold">$294.42</td>
                                <td class="yellow_text bold">$0.00</td>
                                <td class="yellow_text bold ">$294.42 </td>
                                <td class="yellow_text bold ">22.26 </td>
                                <td class="yellow_text bold ">
                                  Not Applicable{" "}
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="pills-profile"
                        role="tabpanel"
                        aria-labelledby="pills-profile-tab"
                      >
                        <div className="table-responsive">
                          <table
                            width="100%"
                            cellspacing="0"
                            cellpadding="0"
                            class="checklist-table remove-space inventory_table"
                          >
                            <thead>
                              <tr>
                                <th width=""></th>
                                <th width="">
                                  Wednesday
                                  <br />
                                  May 25
                                </th>
                                <th width="">
                                  Thursday
                                  <br />
                                  May 26
                                </th>
                                <th width="">
                                  Friday
                                  <br />
                                  May 27
                                </th>
                                <th width="">
                                  Saturday
                                  <br />
                                  May 28
                                </th>
                                <th width="">
                                  Sunday
                                  <br />
                                  May 29
                                </th>
                                <th width="">
                                  Monday
                                  <br />
                                  May 30
                                </th>
                                <th width="">
                                  Tuesday
                                  <br />
                                  May 31
                                </th>
                                <th width="">Total</th>
                                <th width="">% of Revenue</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="blue_text bold">Revenue</td>
                                <td class="blue_text bold">$60.00</td>
                                <td class="blue_text bold">$339.60</td>
                                <td class="blue_text bold">$0.00</td>
                                <td class="blue_text bold">$436.80</td>
                                <td class="blue_text bold">$110.11</td>
                                <td class="blue_text bold">$367.44</td>
                                <td class="blue_text bold">$128.40</td>
                                <td class="blue_text bold">$1,442.35</td>
                                <td class="blue_text bold">100.00</td>
                              </tr>

                              <tr>
                                <td class="bold">Sales</td>
                                <td class=" bold">$55.00</td>

                                <td class=" bold">$312.80</td>

                                <td class=" bold">$0.00</td>

                                <td class=" bold">$400.40</td>

                                <td class=" bold">$101.31</td>

                                <td class=" bold">$326.54</td>

                                <td class=" bold">$119.19</td>

                                <td class=" bold">$1,315.24</td>
                                <td class=" bold">91.19</td>
                              </tr>
                              <tr>
                                <td class=" ">Food</td>
                                <td class=" ">$55.00</td>
                                <td class=" ">$238.00</td>
                                <td class=" ">$0.00</td>
                                <td class=" ">$357.50</td>
                                <td class=" ">$101.31</td>
                                <td class=" ">$267.24</td>
                                <td class=" ">$119.19</td>
                                <td class=" ">$1,138.24 </td>
                                <td class=" ">78.92</td>
                              </tr>

                              <tr>
                                <td class=" ">Beverages</td>
                                <td class=" ">$0.00</td>
                                <td class=" ">$74.80</td>
                                <td class=" ">$0.00</td>
                                <td class=" ">$42.90</td>
                                <td class=" ">$0.00</td>
                                <td class=" ">$59.30</td>
                                <td class=" ">$0.00</td>
                                <td class=" ">$177.00 </td>
                                <td class=" ">12.27</td>
                              </tr>
                              <tr>
                                <td class="pd-left25">Alcoholic Beverages</td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$68.20 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$42.90 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$59.30 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$170.40 </td>
                                <td class=" ">11.81</td>
                              </tr>
                              <tr>
                                <td class="pd-left25">
                                  Non-Alcoholic Beverages
                                </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$6.60 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$0.00 </td>
                                <td class=" ">$6.60 </td>
                                <td class=" ">0.46</td>
                              </tr>
                              <tr>
                                <td class=" bold">Other Income</td>
                                <td class=" bold">$5.00</td>
                                <td class=" bold">$26.80</td>
                                <td class=" bold">$0.00</td>
                                <td class=" bold">$36.40</td>
                                <td class=" bold">$8.80</td>
                                <td class=" bold">$31.80</td>
                                <td class=" bold">$10.70</td>
                                <td class=" bold">$119.50</td>
                                <td class=" bold">8.29</td>
                              </tr>
                              <tr>
                                <td class="blue_text bold">COGS</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">(0.00)</td>
                              </tr>
                              <tr>
                                <td class=" bold">Food</td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">(0)</td>
                              </tr>
                              <tr>
                                <td class=" bold">Beverages</td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">(0)</td>
                              </tr>
                              <tr>
                                <td class="blue_text bold">Labor</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00)</td>
                                <td class="blue_text bold">($0.00) </td>
                                <td class="blue_text bold">(0)</td>
                              </tr>
                              <tr>
                                <td class=" bold">Confirmed Wages</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class="bold">($0.00)</td>
                                <td class=" bold">(0)</td>
                              </tr>
                              <tr>
                                <td class="pd-left25"> Regular Wages </td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">(0)</td>
                              </tr>
                              <tr>
                                <td class="pd-left25">Variable Pay</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">(0)</td>
                              </tr>
                              <tr>
                                <td class="pd-left25">Overtime</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">(0)</td>
                              </tr>
                              <tr>
                                <td class=" bold">Other Payroll Costs</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00)</td>
                                <td class=" bold">($0.00) </td>
                                <td class=" bold">(0)</td>
                              </tr>
                              <tr>
                                <td class="pd-left25">
                                  Employer Contribution{" "}
                                </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">(0)</td>
                              </tr>
                              <tr>
                                <td class="pd-left25">Employee Meals</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00)</td>
                                <td class=" ">($0.00) </td>
                                <td class=" ">(0)</td>
                              </tr>
                              <tr>
                                <td class="yellow_text bold">PRIME COST</td>
                                <td class="yellow_text bold">$0.00 </td>
                                <td class="yellow_text bold">$0.00 </td>
                                <td class="yellow_text bold">$0.00 </td>
                                <td class="yellow_text bold">$0.00 </td>
                                <td class="yellow_text bold">$0.00 </td>
                                <td class="yellow_text bold">$107.53 </td>
                                <td class="yellow_text bold">$0.00 </td>
                                <td class="yellow_text bold ">$0.00 </td>
                                <td class="yellow_text bold ">0</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <div
                        class="tab-pane fade"
                        id="pills-contact"
                        role="tabpanel"
                        aria-labelledby="pills-contact-tab"
                      >
                        ...
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </UserInterface>
  );
};
export default Home;
